import _ from 'lodash'
import { warn } from './logger.js'

const composeClasses = array => {
  return _( array )
    .compact()
    .join( ' ' )
}

const getType = variable => {
  if ( variable?.constructor?.name ) {
    // Handles most valid types
    return variable.constructor.name
  } else {
    // Handles null, undefined
    return _.upperFirst( ( {} ).toString.call( variable ).match( /\s([a-zA-Z]+)/ )[ 1 ].toLowerCase() )
  }
}

const verifyCustomProperties = ( properties, bare, module ) => {
  if ( !bare ) {
    _.each( properties, property => {
      if ( !getComputedStyle( document.documentElement ).getPropertyValue( property ) ) {
        warn( module, `Missing custom property: ${ property }` )
      }
    } )
  }
}

export {
  composeClasses,
  getType,
  verifyCustomProperties,
}
